<template>
  <div class="not-found-container">
    <div class="text-container">
      <p>{{ message }}</p>
      <p>{{ $t('error.notFound.pleaseClick') }} <a class="link link-center" @click="goHome">{{ $t('error.notFound.here') }}</a></p>
      <p>{{ $t('error.notFound.backToHome') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
      component: ''
    }
  },
  created () {
    this.component = this.$route.params.component
  },
  computed: {
    message() {
      const key = 'error.notFound.' + this.component.toLowerCase()
      const translate = this.$t(key)
      return translate === key ? this.$t('error.notFound.default') : translate
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'homePage' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.link {
    color: $primary-color;
    cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.not-found-container {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  margin-top: 30px;
  margin-left: 20px;
  margin-right: 20px;

  background-color: white;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
  border-radius: 2px;

  .text-container {
    width: 100%;
    text-align: center;
    text-justify: inter-word;
    color: $black-color;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .link-center {
    display: inline !important;
  }
}

</style>
